import { Gender } from '@/app/shared/enums';
import {
  AddressInsuranceModel,
  ContactInsuranceModel,
} from '@/app/shared/models';
import { Model } from '@/app/shared/models/model';

export class CustomerInsuranceModel extends Model {
  public Name!: string;
  public Document?: string;
  public DocumentType!: string;
  public Birthdate!: Date | string;
  public Gender!: Gender;
  public Created!: Date;
  public Updated!: Date;

  public Contacts!: ContactInsuranceModel[];
  public Addresses!: AddressInsuranceModel[];
}
